/**
 * @generated SignedSource<<6b1c9f3702dd197b8c2b56932dc8c956>>
 * @relayHash 5e62fa12477c31b6e34abc2474433a92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ed99853890443271211bafc59fd8d139d00fbb8e481259cdc1cfe95cfaa1b947

import type { ConcreteRequest } from 'relay-runtime';
export type WatchSettingsItemTrialDetailsQuery$variables = Record<PropertyKey, never>;
export type WatchSettingsItemTrialDetailsQuery$data = {
  readonly license: {
    readonly trialEndDate: string | null | undefined;
  } | null | undefined;
};
export type WatchSettingsItemTrialDetailsQuery = {
  response: WatchSettingsItemTrialDetailsQuery$data;
  variables: WatchSettingsItemTrialDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "License",
    "kind": "LinkedField",
    "name": "license",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "trialEndDate"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "WatchSettingsItemTrialDetailsQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WatchSettingsItemTrialDetailsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5e62fa12477c31b6e34abc2474433a92",
    "id": "ed99853890443271211bafc59fd8d139d00fbb8e481259cdc1cfe95cfaa1b947",
    "metadata": {},
    "name": "WatchSettingsItemTrialDetailsQuery",
    "operationKind": "query",
    "text": "query WatchSettingsItemTrialDetailsQuery{license{trialEndDate}}"
  }
};
})();

(node as any).hash = "95d5a1d05fc052c62a0995545b6cedc8";

export default node;
